import Carousel from './Carousel';

export * from './Carousel';

export default Carousel;
